export class FileDataGenerationError extends Error {
    constructor(message) {
        const errorMessage = message !== null && message !== void 0 ? message : `Cannot generate data due to error: ${message}`;
        super(errorMessage);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
